import {orgBlockedUsersPath} from '@github-ui/paths'
import {useMutation} from '@github-ui/react-query'
import {useMarkersActions} from '../stores/selectors'
import {produce} from 'immer'
import {verifiedFetch} from '@github-ui/verified-fetch'
import type {Thread} from '@github-ui/diff-lines/conversation-types'

export function useBlockUserFromOrgMutation() {
  const {updateThreads} = useMarkersActions()

  return useMutation({
    mutationFn: async ({
      duration,
      hiddenReason,
      organizationLogin,
      notifyBlockedUser,
      shouldHideComment,
      userLogin,
    }: {
      duration: string
      shouldHideComment: boolean
      hiddenReason: string | undefined
      organizationLogin: string
      notifyBlockedUser: boolean
      userLogin: string
    }) => {
      const formData = new FormData()

      formData.append('duration', duration) // TODO: convert duration to a number
      formData.append('hide_comment', shouldHideComment.toString())
      if (hiddenReason) formData.append('hidden_reason', hiddenReason)
      formData.append('login', userLogin)
      formData.append('send_notification', notifyBlockedUser.toString())

      // Have to use verfiedFetch because wrappers like fetchWithErrorHandling don't support FormData
      await verifiedFetch(orgBlockedUsersPath({owner: organizationLogin}), {
        method: 'POST',
        body: formData,
        redirect: 'manual', // We don't want to follow the redirect, we can update the comments directly
      })
    },
    onSuccess: (_data, variables) => {
      updateThreads(
        produce((oldThreads: Thread[]) => {
          // Find the comments of the blocked user
          const blockedUserComments = oldThreads.flatMap(
            t => t.commentsData?.comments.filter(c => c.author?.login === variables.userLogin),
          )

          if (blockedUserComments.length === 0) return

          for (const comment of blockedUserComments) {
            if (!comment) continue
            comment.viewerCanBlockFromOrg = false
            comment.viewerCanUnblockFromOrg = true
            comment.isHidden = variables.shouldHideComment || comment.isHidden
            comment.minimizedReason = variables.hiddenReason || null
          }
        }),
      )
    },
  })
}
